import { createSlice, createAsyncThunk  } from '@reduxjs/toolkit';
import UserService from "../../services/user-service";

const initialState = {
    loading: false,
    users: [],
    error: ''
}

export const fetchSchemes = createAsyncThunk('scheme/fetchSchemes', async () => {
    const response = await UserService.getSchemes();
    return response.data;
})

const schemeSlice = createSlice({
    name: 'scheme',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchSchemes.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchSchemes.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload
            state.error = ''
        })
        builder.addCase(fetchSchemes.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
        })
    }
})

export default schemeSlice.reducer
